import {NgModule} from '@angular/core';
import '../../utils/string/string-prototype.utils';
import {WindowService} from '../shared/services/window/window.service';
import {configMap} from './config.map';
import {PrismConfigOptions} from './environment-variables.interface';
import {EnvVariables} from './environment-variables.token';

/**
 * factory to set the environment variables
 * @returns {PrismConfigOptions}
 */
export function environmentFactory(): PrismConfigOptions {
  return getConfig(new WindowService());
}

/**
 * Gets the config file
 * @param {WindowService} windowService instance of the WindowService
 * @returns {PrismConfigOptions}
 */
export function getConfig(windowService: WindowService): PrismConfigOptions {
  const domain = windowService.window.location.hostname.split('.');
  const buIndex = domain.findIndex((domainPart) => configMap.sites.indexOf(domainPart) >= 0);
  const bu = domain[buIndex];
  const env = domain.slice(0, buIndex).join('.');
  const configs = configMap.configs;

  if (env === 'localhost') {
    return configs.cbsi.localhost;
  }
  if (!configs[bu]) {
    return configs.default;
  }
  if (!configs[bu][env]) {
    return configs[bu].default;
  }

  return configs[bu][env];
}

/**
 * Module for environment configurations
 */
@NgModule({
  providers: [
    {
      provide: EnvVariables,
      // useFactory instead of useValue so we can easily add more logic as needed.
      useFactory: environmentFactory,
    },
  ],
})
export class EnvironmentsModule {
}



// WEBPACK FOOTER //
// ./src/app/environment-variables/environment-variables.module.ts